import { useLoginContext } from "../../Contexts/LoginContext";
import { resetConfig } from "../../utilities/helper";
import Button from "../../Components/Button";
import React, { useEffect } from "react";

function LoginAccountLocked() {
  const { mobileNumber, navigate, setMobileNumber, setConfigRestarted } =
    useLoginContext();

  useEffect(() => {
    if (!mobileNumber) {
      navigate("/", { replace: true });
    }
  }, []);

  const handleBack = () => {
    navigate("/", { replace: true });
    setMobileNumber("");
    resetConfig();
    setConfigRestarted(true);
  };

  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center sm:justify-center cursor-default">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="flex flex-row p-3">
            <div className="text-center text-md font-bold flex-grow">
              Account Locked
            </div>
          </div>

          <div className="p-3">
            <div className="text-center">
              Your account has been locked due to maximum failed attempts.
              Please contact Maxicare at{" "}
              <span className="text-[#0A53C9] font-semibold">
                (02)7908 6964
              </span>
              {/* */}.
            </div>
            <Button
              className="h-12 w-full transition ease-in-out delay-75 rounded-xl text-white bg-[#0947AB] mt-4"
              onClick={handleBack}
            >
              Back Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginAccountLocked;
